/** Add active state to button on seamfree landing page **/
const currentURL = window.location.href;
const seamfreeURLs = document.querySelectorAll('.seamfree-link');

seamfreeURLs.forEach(url => {
  if (url.href === currentURL) {
    url.classList.add('active');
  }
});

/* Script for Simple Full Width Slider */
function simpleFullWidthSlider(activeSlide = 0) {
  const slider = document.querySelector('.simple-slider');
  if (!slider) return;

  const slides = slider.querySelectorAll('.simple-slider__slide-image');
  let touchstartX = 0;
  let touchendX = 0;

  // Show the first slide
  showSlide(activeSlide);

  for (const slide of slides) {
    slide.addEventListener('touchstart', handleTouchStart);
    slide.addEventListener('touchend', handleTouchEnd);
    slide.addEventListener('click', handleClick);
  }

  function handleTouchStart(event) {
    touchstartX = event.touches[0].clientX;
  }

  function handleTouchEnd(event) {
    touchendX = event.changedTouches[0].clientX;
    handleSwipe();
  }

  function handleClick() {
    const clickedSlide = Array.from(slides).indexOf(this);
    showSlide(clickedSlide);
  }

  // Logic for determining swipe direction
  function handleSwipe() {
    const swipeDistance = touchstartX - touchendX;
    if (swipeDistance > 50) {
      // Swiped left
      const nextSlide = (activeSlide + 1) % slides.length;
      showSlide(nextSlide);
    } else if (swipeDistance < -50) {
      // Swiped right
      const prevSlide = (activeSlide - 1 + slides.length) % slides.length;
      showSlide(prevSlide);
    }
  }

  function showSlide(slideIndex) {
    
    if(slides[slideIndex].classList.contains('active')){
      return window.location = slides[slideIndex].dataset.productPage;
    }
    
    slides.forEach((slide) => {
      slide.classList.remove('active');
    });
    slides[slideIndex].classList.add('active');
    activeSlide = slideIndex;
  }

   setInterval(function(){
    const activeSlide = slider.querySelector('.simple-slider__slide-image.active');
    const arraySlides = Array.from(slides);
    const currentIndex = arraySlides.indexOf(activeSlide);
    if(currentIndex + 1 == arraySlides.length){
      showSlide(0);
    } else {
      showSlide(currentIndex + 1);
    }
  }, 5000)
  
}
simpleFullWidthSlider(2);

/* Script for Background Fill Section */
function updateAnimation() {
  const container = document.querySelector('.background-fill');
  if (!container) return;

  const containerHeight = container.clientHeight;
  let isAnimationStarted = false;

  // Calculate the offset of the container from the top of the viewport
  const offsetFromViewportTop = container.getBoundingClientRect().top;

  // Calculate the scroll distance relative to the container's top
  const scrollDistance = Math.min(Math.max(offsetFromViewportTop, 0), containerHeight);

  // Calculate the percentage of scroll progress from the container's top to bottom
  const scrollPercentage = ((containerHeight - scrollDistance) / containerHeight) * 100;

  // Set the CSS variable '--portion' to the scroll percentage
  container.style.setProperty('--portion', `${scrollPercentage}%`);

  // If the container is fully visible and the animation hasn't started yet, set the flag to true
  if (scrollDistance >= containerHeight && !isAnimationStarted) {
    isAnimationStarted = true;
  }
}
window.addEventListener('scroll', updateAnimation);

// Hide yotpo widget on gift card product template
document.addEventListener("DOMContentLoaded", function () {
  const productGiftCard = document.querySelector('.section .product.is-gift-card');

  if (productGiftCard) {
    const yotpoWidget = document.querySelector('.yotpo-widget-instance');

    if (yotpoWidget) {
      yotpoWidget.style.display = 'none';
    }
  }
});



const selectSitesActiveList = document.querySelectorAll('.select-sites--active');

selectSitesActiveList.forEach(function (selectSitesActive) {
  const selectSitesContent = selectSitesActive.nextElementSibling;

  selectSitesActive.addEventListener('click', function (e) {
    e.preventDefault();
    selectSitesContent.classList.toggle('active');
  });

  document.addEventListener('click', function (e) {
    const dropdown = selectSitesActive;
    const dropdownContent = dropdown.nextElementSibling;

    if (!dropdown.contains(e.target)) {
      dropdownContent.classList.remove('active');
    }
  });
});

const $modelCaptionButtons = $('.model-caption-btn');
if($modelCaptionButtons.length > 0){
  $('.model-caption-btn').click(function(){
    $('.model-caption').toggle()
  })
}
